import React from 'react'

import { FeaturedWideCardProps } from '../index'

export const FeaturedWideCard = ({
    title,
    subTitle,
    cardURL,
    bgImage
}: FeaturedWideCardProps) => {
    return (
        <div
            className="flex w-3/5 rounded-2xl relative"
            style={{
                backgroundImage: bgImage
                    ? `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url(${bgImage})`
                    : 'linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1))'
            }}
        >
            <a href={cardURL} target="_blank" className="relative" rel="noreferrer">
                <div>
                    <p className="text-lg font-medium text-white p-4 p-2">{title}</p>
                    <p className="text-md text-white p-4 p-2">{subTitle}</p>
                </div>
            </a>
        </div>
    )
}
